import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeviceRowSchema } from './shapes';

export const AssignDeviceBodySchema = z.object({
  userId: z.string().uuid().nullable(),
  note: z.string().trim().max(500).optional(),
});
export type AssignDeviceBody = z.infer<typeof AssignDeviceBodySchema>;

export const AssignDeviceResponseSchema = z.object({
  data: DeviceRowSchema,
});

export const assignDevice = defineEndpoint({
  method: 'POST',
  path: '/v1/devices/:deviceId/assign',
  params: z.object({ deviceId: z.string().uuid() }),
  query: z.object({}),
  body: AssignDeviceBodySchema,
  response: AssignDeviceResponseSchema,
});
